module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "topbar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "topbar-meta"
  }, [(_vm.loadingDashboard) ? _c('div', {
    staticClass: "loading-indicator"
  }, [_c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedTimeOption.value === 'custom') ? _c('div', {
    staticClass: "d-flex flex-row align-items-center mr-2"
  }, [_c('i', {
    staticClass: "ico ico-calendar fs-large mr-2 accent-icon"
  }), _vm._v(" "), _c('date-picker-new', {
    key: _vm.pickerKey,
    staticClass: "dateRangePicker",
    class: {
      'is-disabled': _vm.loadingDashboard
    },
    attrs: {
      "range": true,
      "clearOutside": true,
      "showFromTo": false
    },
    on: {
      "input": _vm.dateRangeChanged
    },
    model: {
      value: (_vm.customDate),
      callback: function($$v) {
        _vm.customDate = $$v
      },
      expression: "customDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "range-pill",
    class: {
      'is-disabled': _vm.loadingDashboard
    }
  }, _vm._l((_vm.timeOptions), function(opt) {
    return _c('button', {
      key: opt.value,
      class: {
        active: _vm.selectedTimeOption.value === opt.value
      },
      attrs: {
        "disabled": _vm.loadingDashboard
      },
      on: {
        "click": function($event) {
          return _vm.selectRange(opt)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(opt.label) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "kpi-row"
  }, _vm._l((_vm.kpis), function(kpi) {
    return _c('kpiCard', {
      key: kpi.label,
      attrs: {
        "accent": kpi.accent,
        "label": kpi.label,
        "value": kpi.value,
        "deltaType": kpi.deltaType
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "sec-grid"
  }, [_c('channelMix', {
    attrs: {
      "channels": _vm.channels
    }
  }), _vm._v(" "), _c('topAgents', {
    attrs: {
      "agents": _vm.agents
    }
  }), _vm._v(" "), _c('topExperiences', {
    attrs: {
      "experiences": _vm.experiences
    }
  }), _vm._v(" "), _c('guestOrigin', {
    attrs: {
      "origins": _vm.origins
    }
  })], 1), _vm._v(" "), _c('reportsCenter', {
    attrs: {
      "subTitle": _vm.cardLabel,
      "dateFrom": _vm.pickerDateFrom,
      "dateTo": _vm.pickerDateTo
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar-title"
  }, [_c('h1', {
    staticClass: "head"
  }, [_vm._v("Dashboard")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1c6ea9b3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c6ea9b3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/dashboard.vue
// module id = 3023
// module chunks = 0